import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import classnames from 'classnames';
import { ListItem, Container, Label, Value } from '../../../components/list';
import { toggleModal } from '../../../store/reducers/modals';
import styles from '../../../styles/widgets/mab/property-data.module.scss';
import { AffiliateIcon } from '../../../components/icons/affiliate-icon';

export const PropertyDataComponent = ({ to, label, value, className, onClick, faqDetails }) => (
  <ListItem className={className} keyline='top'>
    <Container to={to} onClick={onClick} className={classnames({ [styles.pointer]: !!faqDetails })}>
      <div className={styles.wrapper}>
        <Label>{label}</Label>
        {faqDetails && <AffiliateIcon name='info' className={styles.icon} />}
      </div>
      <Value>{value || '-'}</Value>
    </Container>
  </ListItem>
);

export const PropertyData = compose(
  connect(null, { toggleModal }),
  withHandlers({
    onClick:
      ({ faqDetails, label, toggleModal }) =>
      () => {
        if (faqDetails) toggleModal(true, 'help', { title: label, body: faqDetails });
      }
  })
)(PropertyDataComponent);
